(function() {

  var afterExpandCollapseFns = [];
  window.afterExpandCollapse = function(fn) {
    afterExpandCollapseFns.push(fn);
	}
	let leftWidth = 250
	let rightWidth = 270
	window.collapse = function(side){
		$('#route_container').css('background', '#FFF');
		var col = $('.fullpage_'+side+'_col');
		if (side=='left') {
			leftWidth = $('.fullpage_left_col').outerWidth()
			$('#map,#central').animate({marginLeft:0},50, function(){
				$('#route_container').css('background', '#333');
        _.each(afterExpandCollapseFns, function(fn) { fn(); });
			});
		}
		if (side=='right') {
			rightWidth = $('.fullpage_right_col').outerWidth()
			$('#map,#central').animate({marginRight:0},50, function(){
        _.each(afterExpandCollapseFns, function(fn) { fn(); });
      });
		}
		col.children('.collapse').removeClass('collapse').addClass('expand');
    var toAnimate;
    if(side === 'left')
      toAnimate = {left: -col.outerWidth()};
    else
      toAnimate = {width: 0};
		col.animate(toAnimate, 50, function(){
			col.addClass('hidden_'+side+'_col');
		});
		col.children('#ds_v, #ds_vl').hide();
		return false;
	}
	window.expand = function(side){
		var col = $('.fullpage_'+side+'_col');
		var width = leftWidth + 'px'
		col.children('.expand').addClass('collapse').removeClass('expand');
		if (side=='left') {
      $('.fullpage_left_col a.left').show();
			$('#map,#central').animate({marginLeft:leftWidth},50, function(){
        col.children('#ds_v, #ds_vl').show();
        _.each(afterExpandCollapseFns, function(fn) { fn(); });
			});
		}
		if (side=='right') {
			$('#map,#central').animate({marginRight:rightWidth},50, function(){
        col.children('#ds_v, #ds_vl').show();
        _.each(afterExpandCollapseFns, function(fn) { fn(); });
			});
			width = rightWidth + 'px'
		}
    var toAnimate;
    if(side === 'left')
      toAnimate = {left: 0};
    else
      toAnimate = {width: width};
		col.animate(toAnimate, 50, function(){
			col.removeClass('hidden_'+side+'_col');
		});
		return false;
	}
	window.toggleSidebars = function(side){
		var col = $('.fullpage_'+side+'_col');
		var hidden_class_name = 'hidden_'+side+'_col';
		if (col.hasClass(hidden_class_name)) {
			window.expand(side);
		} else {
			window.collapse(side);
		}
	}
})();
$(function(){
  // cant have the left side resizable without doing something smarter.  upgrading to jquery 1.4 made the resizable ui plugin set the left bar as relative, not absolute, which forces the map to flow below.
  //$('.fullpage_left_col').resizable({handles: 'e', maxWidth: 500, minWidth: 240, resize: function(event, ui) {
        //$('#map').css('margin-left', ui.helper.width());
      //}
  //});

  $('.contracted').next('div').hide();

	$(document).on("click", '.left.collapse', function(){
		collapse('left');
		Application.setPreference('route_planner_left_sidebar_closed', true, true);
		return false;
	});
	$(document).on("click", '.right.collapse', function(){
		collapse('right');
    Application.setPreference('route_planner_right_sidebar_closed', true, true);
		return false;
	});
	$(document).on("click", '.expand.left', function(){
		expand('left');
		Application.setPreference('route_planner_left_sidebar_closed', false, true);
		return false;
	});
	$(document).on("click", '.expand.right', function(){
		expand('right');
    Application.setPreference('route_planner_right_sidebar_closed', false, true);
		return false;
	});

	$('.toggle_next').click(function(){
    var $next = $(this).next();
    //the toggle element can be wrapped in a tooltip and still work
    if($next.length == 0) $next = $(this).parent().next();
		$(this).toggleClass('contracted');
    $next.slideToggle(400);
	});
});



// WEBPACK FOOTER //
// ./public/javascripts/fullpage.js